// ---
// This file sets up all singletons shared by the web component application
// ---
import { MailBox, StyleRepository, TokenService } from "./services";
const win = window;
export const bootstrap = () => {
  // The singleton mailBox is used to communicate between
  // custom elements and the main bundles
  const mailBox = new MailBox();
  // The singleton StyleRepository is used by some apps
  // to load webpacked CSS into the shadow DOM
  const styleRepository = new StyleRepository(mailBox);
  // The token repository manages the logic possibly multiple token contexts
  const tokenService = new TokenService(mailBox);
  win.MD = win.MD || {};
  win.MD.mailBox = mailBox;
  win.MD.styleRepository = styleRepository;
  win.MD.tokenService = tokenService;
  return {
    mailBox,
    styleRepository,
    tokenService
  };
};
export const obtainMD = () => win.MD;
export const obtainMailBox = () => obtainMD().mailBox;
export const obtainStyleRepository = () => obtainMD().styleRepository;
export const obtainTokenService = () => obtainMD().tokenService;